import {fetchDelete, fetchGet, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const addPost = async({ token, post }) => {
  const url = `${generateEndpoint('createPost')}`
  return fetchPost(url, token, { post })
}

export const updatePostById = async({ token, post }) => {
  const url = `${generateEndpoint('updatePost')}`
  return fetchPatch(url, token, { post })
}

export const deletePostById = async({ token, id }) => {
  const url = `${generateEndpoint('deletePost')}`
  return fetchDelete(url, token, { id })
}

export const getPosts = async() => {
  const url = `${generateEndpoint('getPosts')}`;
  return fetchGet(url, null);
}
